"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isTurnNoOutputData = exports.turnNoOutputChunk = exports.TURN_NO_OUTPUT_DATA_TYPE = void 0;
exports.TURN_NO_OUTPUT_DATA_TYPE = 'data-turn-no-output';
const turnNoOutputChunk = () => ({
    type: exports.TURN_NO_OUTPUT_DATA_TYPE,
    data: {},
    transient: true,
});
exports.turnNoOutputChunk = turnNoOutputChunk;
const isTurnNoOutputData = (chunk) => chunk?.type === exports.TURN_NO_OUTPUT_DATA_TYPE;
exports.isTurnNoOutputData = isTurnNoOutputData;
//# sourceMappingURL=turn-no-output.js.map